import React from 'react'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import CloseIcon from '@material-ui/icons/Close'
import styles from './dashboardDialogStyles'
import { trackWidgetClick } from '../../../../helpers/trackWidgetClick'

function DashboardDialog({
  open,
  dialogTitle,
  dialogContent,
  onCloseDialog,
  closeDialog,
  dispatch,
  maxWidth,
  contentClassName,
  showTitleCloseButton,
  widgetId,
}) {
  const classes = styles()
  const closeDialogAction = () => {
    trackWidgetClick(dispatch, widgetId || 'DashboardDialog', 'Close', {
      widgetId,
    })
    if (onCloseDialog) {
      dispatch(onCloseDialog())
    }
    dispatch(closeDialog())
  }
  return (
    <Dialog
      open={open}
      maxWidth={maxWidth || 'sm'}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          wrap="nowrap"
        >
          <Grid item xs zeroMinWidth>
            {dialogTitle}
          </Grid>
          {showTitleCloseButton && (
            <Grid item>
              <IconButton aria-label="close" onClick={closeDialogAction}>
                <CloseIcon className={classes.titleCloseIcon} />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </DialogTitle>
      <DialogContent dividers className={contentClassName}>
        {dialogContent}
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          className={classes.dialogActionButton}
          onClick={closeDialogAction}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DashboardDialog
